var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop } from 'vue-property-decorator';
import { ExportConfigService } from '~/services/management-service/export-config.service';
import { ExportAssistManagementService } from '~/services/dataimp-service/export-assist-management.service';
var FollowRecordExport = /** @class */ (function (_super) {
    __extends(FollowRecordExport, _super);
    function FollowRecordExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            configId: '',
        };
        _this.submitLoading = false;
        _this.AllConfigs = [];
        return _this;
    }
    FollowRecordExport.prototype.created = function () {
        var _this = this;
        this.exportConfigService
            .getAllConfigs({ exportType: this.exportType })
            .subscribe(function (data) { return (_this.AllConfigs = data); }, function (err) { });
    };
    FollowRecordExport.prototype.submit = function () {
        var _this = this;
        if (this.model.configId === '') {
            this.$message('请选择导出模板');
            return;
        }
        var exportModel = Object.assign({}, this.model, this.exportData);
        if (exportModel.caseDataStatus === '')
            delete exportModel.caseDataStatus;
        this.exportAssistManagementService
            .exportFolllowRecord(exportModel)
            .subscribe(function (data) {
            _this.$message.success('导出成功!');
            _this.success();
            _this.submitLoading = false;
        }, function (err) {
            _this.submitLoading = false;
        });
    };
    FollowRecordExport.prototype.close = function () {
        this.reset();
    };
    FollowRecordExport.prototype.success = function () {
        this.close();
    };
    FollowRecordExport.prototype.reset = function () {
        this.model.configId = '';
    };
    __decorate([
        Dependencies(ExportAssistManagementService)
    ], FollowRecordExport.prototype, "exportAssistManagementService", void 0);
    __decorate([
        Dependencies(ExportConfigService)
    ], FollowRecordExport.prototype, "exportConfigService", void 0);
    __decorate([
        Prop({ required: true })
    ], FollowRecordExport.prototype, "exportData", void 0);
    __decorate([
        Prop({ default: "FOLLOW_RECORD", type: String })
    ], FollowRecordExport.prototype, "exportType", void 0);
    __decorate([
        Emit()
    ], FollowRecordExport.prototype, "close", null);
    __decorate([
        Emit()
    ], FollowRecordExport.prototype, "success", null);
    FollowRecordExport = __decorate([
        Component({
            components: {},
        })
    ], FollowRecordExport);
    return FollowRecordExport;
}(Vue));
export default FollowRecordExport;
